import vmClient from 'app/services/vmClient';
import { Entity, IEntityType } from '../../types/entity';
import { Exercise, IExercise } from 'app/constants/schemas/Exercise';
import { Issue, IIssue } from 'app/constants/schemas/Issue';
import {
  ILessonHeader,
  ILessonHeaderAssociations,
  lessonHeaderAttributes,
  lessonHeaderAssociations,
} from 'app/constants/schemas/LessonHeader';

interface ILessonAssociations extends ILessonHeaderAssociations {
  exercises: IExercise[];
  issues: IIssue[];
}

export interface ILesson extends ILessonHeader {
  associations: ILessonAssociations;
}

export type Lesson = Entity<ILesson>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Lesson: IEntityType<ILesson> = vmClient.defineClass({
  typeName: 'Lesson',
  version: 17,
  persisted: true,
  lockable: true,
  attributes: {
    ...lessonHeaderAttributes,
  },
  associations: {
    ...lessonHeaderAssociations,
    exercises: {
      type: Exercise,
      notNull: true,
      collection: true,
    },
    issues: {
      type: Issue,
      collection: true,
      notNull: true,
    },
  },
});
